import { getItem } from "@garantidos/utils"

import isClient from "@mobi/utils/browser/isClient"

import CpfOneClick from "./microSteps/Cpf"
import NameOneClick from "./microSteps/Name"

export { default as CpfOneClick } from "./microSteps/Cpf"
export { default as NameOneClick } from "./microSteps/Name"
export { default as EmailOneClick } from "./microSteps/Email"
export { default as PhoneNumberOneClick } from "./microSteps/PhoneNumber"

const OneClickSoftLead = (props) => {
  const cpf = isClient() ? getItem("cpfFromHero") : ""

  return <>{cpf ? <NameOneClick {...props} /> : <CpfOneClick {...props} />}</>
}

export default OneClickSoftLead
